export interface IPts {
  analyteCode: number;
  analyte: string;
  methodCode: number;
  matrix: string;
  results: IPtResults[];
  methodDesc: string;
  techKey: number;
  technology: string;
  passed: boolean;
}

export interface IPtResults {
  resultId: number;
  ptFileId: number;
  orelapId: string;
  ptProvider: string;
  result: string;
  studyNo: string;
  closeDate: Date;
  matrix: string;
  methodCode: number;
  analyteCode: number;
}

export interface IPtViewResults {
  analyteCode: number;
  analyte: string;
  methodCode: number;
  matrix: string;
  results: IPtResults[];
  methodDesc: string;
  techKey: number;
  technology: string;
  passed: boolean;
  resultDate0: string;
  resultDate1: string;
  resultDate2: string;
  resultDate3: string;
  resultDate4: string;
  resultDate5: string;
  resultDate6: string;
  resultDate7: string;
  resultDate8: string;
  resultDate9: string;
  resultDate10: string;
  resultDate11: string;
  resultDate12: string;
}